var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share button__container button__circle--white",class:{button__circle : _vm.haveBg}},[_c('img',{staticClass:"share__icon",attrs:{"src":_vm.shareIcon,"alt":"Share the song icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }